import React from 'react';

function Cooperativa() {
  return (
    <>
      <h1>A Cooperativa</h1>
      <p>A COOPERATIVA DE ECONOMIA E CREDITO MUTUO DOS FUNCIONARIOS DO GRUPO
        GERDAU – COCRAFI – Autorizada e fiscalizada pelo Banco central do Brasil. Fundada em 06
        de julho de 1976. A COCRAFI, é uma instituição financeira componente do Sistema
        Financeiro Nacional, motivo pelo qual realiza a maioria das operações que os bancos
        oferecem, com grande diferencial que as sobras (nos bancos, lucros) são distribuídas,
        anualmente aos associados, proporcionalmente as operações por eles realizadas (juros
        pagos nas operações de credito).
      </p>
      <h3>Missão</h3>
      <p className="institucionalText">Captar e gerir com excelência os recursos financeiros dos associados, bem como
        fomentar seu desenvolvimento com ênfase na cooperação.
      </p>
      <h3>Visão</h3>
      <p className="institucionalText">Ser conhecida e reconhecida pelos empregados do Grupo Gerdau como Instituição
        Financeira, contribuindo para o desenvolvimento econômico-financeiro e social em sua área
        de atuação.
      </p>
      <h3>Valores</h3>
      <ul>
        <li>Transparência;</li>
        <li>Credibilidade;</li>
        <li>Cooperativismo;</li>
        <li>Ética;</li>
        <li>Responsabilidade;</li>
        <li>Honestidade;</li>
        <li>Democracia;</li>
        <li>Legalidade.</li>
      </ul>
    </>
  )
}

export default Cooperativa;